import { useTranslation } from 'react-i18next';

import { StyledBadge } from 'components/shared';
import { useOrderStatuses } from 'constants/orderStatuses';
import { OrderStatus } from 'interfaces';
import { getOrderIdLabel } from 'utils/functions';

import styles from './OrderDetailsHeader.module.css';

type OrderDetailsHeaderProps = {
   orderData: OrderDetailsHeaderOrderData;
};

export type OrderDetailsHeaderOrderData = {
   id: string;
   status?: OrderStatus;
   createdDate: string;
};

const OrderDetailsHeader = ({ orderData }: OrderDetailsHeaderProps) => {
   const { t } = useTranslation();
   const { id, status, createdDate } = orderData;

   const { ORDER_STATUSES_BADGE_DATA } = useOrderStatuses();

   return (
      <div className={styles.headerContainer}>
         <div className={styles.headerLeft}>
            <div className={styles.headerLeftInnerContainer}>
               <h2>
                  {t('order_details.title')} {getOrderIdLabel(id)}
               </h2>
               {status && (
                  <StyledBadge
                     text={ORDER_STATUSES_BADGE_DATA[status].label}
                     variant={ORDER_STATUSES_BADGE_DATA[status].variant}
                  />
               )}
            </div>
            <p>
               {t('client_orders.table.order_date')}:{' '}
               {new Date(createdDate).toLocaleDateString('en-GB')}
            </p>
         </div>
      </div>
   );
};

export default OrderDetailsHeader;
